<template>
    <div class="c-solution-home">
        <LayoutContent>
            <div class="c-solution-content">
                <div class="content-side">
                    <div class="c-video-box">
                        <div class="cd-video-space">
                            <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/home/solution-home-video-bg.png" />
                        </div>
                        <!-- <div class="cd-player-wapper">
                            <span class="player-button"><i class="gvfont gvfont-player"></i></span>
                        </div> -->
                    </div>
                </div>
                <div class="content-main">
                    <div class="c-detail-box">
                        <div class="detail-header">
                            <p class="c-title-text">
                                {{ $t("main:全球领先的") }}<span class="text-import">{{ $t("main:游戏语音") }}</span
                                >{{ $t("main:解决方案") }}
                            </p>
                        </div>
                        <div class="detail-content">
                            <ul class="c-detail-list-box">
                                <li class="list-item">{{ $t("main:实现跨平台终端、跨区域的实时语音聊天") }}</li>
                                <li class="list-item">{{ $t("main:数据隐私合规符合GDPR") }}</li>
                                <li class="list-item">{{ $t("main:语音算法写入高通最新款的芯片中") }}</li>
                                <li class="list-item">{{ $t("main:拥有独家的文明语音、魔音等创新功能") }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutContent>
    </div>
</template>

<script>
import LayoutContent from "@/components/UI/LayoutContent.vue";
export default {
    name: "SolutionHome",
    components: { LayoutContent },
};
</script>

<style scoped lang="less">
@import "/web/src/assets/css/theme.less";
.c-solution-home {
    display: flex;
    align-items: center;
    min-height: 574px;
    padding-left: 24px;
    padding-right: 24px;
    background-color: #151829;
}
.c-solution-content {
    display: flex;
    align-items: center;
    padding: 16px 0;
    .content-side {
        & + .content-main {
            margin-left: 72px;
        }
    }
    .content-main {
        flex: 1;
    }
}
.c-video-box {
    position: relative;
    // cursor: pointer;
    // transition: ease-in-out 0.4s;
    // &:hover {
    //     .cd-video-space {
    //         opacity: 0.64;
    //         transition: ease-in-out 0.4s;
    //     }
    // }
    .cd-video-space {
        width: 580px;
        transition: ease-in-out 0.4s;
        img {
            width: 100%;
        }
    }
    .cd-player-wapper {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .player-button {
            .gvfont {
                font-size: 72px;
                color: #fff;
            }
        }
    }
}
.c-detail-box {
    .detail-header {
        & + .detail-content {
            margin-top: 32px;
        }
    }
}
.c-title-text {
    font-size: @title-font-size;
    color: #fff;
    .text-import {
        color: @primary-color;
    }
}
.c-detail-list-box {
    .list-item {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #8e919a;
        &::before {
            content: "";
            display: inline-block;
            width: 2px;
            height: 2px;
            margin-right: 8px;
            border-radius: 50%;
            background-color: #8e919a;
        }
        & + .list-item {
            margin-top: 8px;
        }
    }
}
@media only screen and (max-width: 1200px) {
    .c-solution-home {
        min-height: 400px;
    }
    .c-video-box {
        .cd-video-space {
            width: 480px;
        }
    }
    .c-title-text {
        font-size: 32px;
    }
    .c-solution-content {
        .content-side {
            & + .content-main {
                margin-left: 40px;
            }
        }
    }
    .c-detail-list-box {
        .list-item {
            font-size: 14px;
            & + .list-item {
                margin-top: 4px;
            }
        }
    }
    .c-detail-box {
        .detail-header {
            & + .detail-content {
                margin-top: 16px;
            }
        }
    }
}
@media only screen and (max-width: 992px) {
    .c-solution-home {
        min-height: 320px;
    }
    .c-video-box {
        .cd-video-space {
            width: 400px;
        }
        .cd-player-wapper {
            .player-button {
                .gvfont {
                    font-size: 56px;
                }
            }
        }
    }
}
@media only screen and (max-width: 768px) {
    .c-solution-home {
        min-height: 240px;
    }
    .c-video-box {
        .cd-video-space {
            width: 320px;
        }
    }
    .c-title-text {
        font-size: 24px;
    }
    .c-solution-content {
        .content-side {
            & + .content-main {
                margin-left: 32px;
            }
        }
    }
    .c-detail-list-box {
        .list-item {
            & + .list-item {
                margin-top: 4px;
            }
        }
    }
    .c-detail-box {
        .detail-header {
            & + .detail-content {
                margin-top: 8px;
            }
        }
    }
}
@media only screen and (max-width: 576px) {
    .c-solution-home {
        min-height: 240px;
        padding-top: 24px;
        padding-bottom: 24px;
    }
    .c-video-box {
        .cd-video-space {
            width: 100%;
        }
    }
    .c-title-text {
        font-size: 24px;
    }
    .c-solution-content {
        flex-direction: column;
        align-items: flex-start;
        .content-side {
            & + .content-main {
                margin-left: 0;
                margin-top: 24px;
            }
        }
    }
    .c-detail-list-box {
        .list-item {
            & + .list-item {
                margin-top: 4px;
            }
        }
    }
    .c-detail-box {
        .detail-header {
            & + .detail-content {
                margin-top: 8px;
            }
        }
    }
}
</style>
